<template>
  <div class="">
    <p class="history__status" :class="statusClass">
      {{ status }}<br>
      <span class="__substatus text-center">{{ substatus }}</span>
    </p>
  </div>
</template>

<script>
  export default {
    name: 'OrderStatus',
    props: {
      order: {
        type: Object,
        required: true
      }
    },
    computed: {
      status () {
        return {
          0: 'รอชำระเงิน',
          1: 'คุณได้ยื่นเอกสารแล้ว รอยืนยันชำระเงิน',
          2: 'ชำระเงินแล้ว',
          3: 'ยกเลิก'
        }[this.order.status || 0]
      },
      substatus () {
        return {
          0: '',
          1: 'ประมวลผลนานเกินไป',
          2: 'payment gateway ไม่ตอบสนอง',
          3: 'ผิดพลาด',
          4: '',
          5: 'หมดเวลาโอนเงิน'
        }[this.order.substatus || 0]
      },
      isBankTransfer () {
        return this.order.payment_method === 'bank_transfer'
      },
      isBankTransferExpired () {
        return this.isBankTransfer && this.order.status === 3 && this.order.substatus === 5
      },
      isPending () {
        return !this.order.status
      },
      isWaitForApprove () {
        return this.order.status === 1
      },
      isPaid () {
        return this.order.status === 2
      },
      isCancelled () {
        return this.order.status === 3
      },
      statusClass () {
        if (this.isBankTransfer && this.order.substatus === 4) {
          return '-warning'
        }

        if (this.order.substatus > 0) {
          return '-error'
        }

        return {
          0: '-warning',
          1: '-info',
          2: '-success',
          3: ''
        }[this.order.status || 0]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// OrderStatus.vue?37c81fa5